import React, { Component } from "react";

class About extends Component {
  // const { state } = this.props.location;
  // window.location = state ? state.from.pathname : "/";
  render() {
    return (
      <div className="text-center">
        <h3 className="">Sobre</h3>
        {/* <h5 className="text-secondary" style={{ marginTop: 100 }}> */}
        <h5 className="text-secondary mt-4">
          O UniNotas é uma plataforma que permite aos actuais e ex-estudantes
          universitários a avaliação anónima das suas universidades,
          compreendendo diversos aspectos que englobam desde a infra-estrutura
          até a qualidade de ensino.
        </h5>
        <h5 className="text-secondary mt-5">
          Serve de um guia para futuros estudantes do ensino superior que podem
          visualizar as avaliações e interagir com outros estudantes.
        </h5>
        <h5 className="text-secondary mt-5">
          Proporciona as universidades melhor percepção da qualidade dos seus
          serviços, tanto nos aspectos positivos, quanto nos aspectos em que
          podem melhorar para potencializar os seus ganhos.
        </h5>
        <h3 className="mt-5">Contacto</h3>
        <h5 className="text-secondary mt-4">Email: unninotas@gmail.com</h5>
      </div>
    );
  }
}

export default About;
